import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** Corner convenience store: counter with the clerk, shelves and fridges. */
const b = new MapBuilder(14, 10, ' ');
b.room(0, 0, 14, 10, ',');
b.fill(6, 9, 2, 1, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });
const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });

const decor: Decor[] = [
  { kind: 'storeFridge', ...at(9, 2), w: px(5), solid: box(6.5, 2, 5, 12) },
  { kind: 'storeShelf', ...at(4, 5), w: px(4), solid: box(2, 5, 4, 10) },
  { kind: 'storeShelf', ...at(10, 5), w: px(4), solid: box(8, 5, 4, 10) },
  { kind: 'storeShelf', ...at(10, 7), w: px(4), solid: box(8, 7, 4, 10), variant: 1 },
  { kind: 'poster', x: px(2), y: 3, wall: true, variant: 1 },
  { kind: 'clock', x: px(12), y: 2, wall: true },
];

export const store: MapDef = {
  id: 'store',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#eef3f2', wallLight: '#ffffff', wainscot: '#3fa36f', wallTop: '#26302c' },
  doors: [{ tiles: [[6, 9], [7, 9]], to: 'town', arrive: { x: px(9), y: px(36), facing: 'down' } }],
  decor,
  areas: [{ key: 'store', rect: { x: 0, y: 0, w: px(14), h: px(10) } }],
  lights: [
    { x: px(4), y: px(4), r: 80, color: '240,250,255' },
    { x: px(10), y: px(4), r: 80, color: '240,250,255' },
  ],
};
